export default from './login-modal';



// WEBPACK FOOTER //
// ./app/containers/login-modal/index.js